import { useEffect } from "react";
import ReactDOM from "react-dom";
import { SvgIcons } from "../../../../SharedComponents/SvgIcons/SvgIcons";
import { PORTAL_ROOT_ID } from "../constants";
import styles from "./style.module.css";

export const Popup = ({ children, onClose, contentClassName = "", usePortal = true }) => {
    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        document.addEventListener("keydown", handleEsc);
        return () => {
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
            document.removeEventListener("keydown", handleEsc);
        };
    }, [onClose]);

    const content = (
        <div className={styles.overlay} onClick={onClose}>
            <div className={`${styles.content} ${contentClassName}`} onClick={e => e.stopPropagation()}>
                <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">
                    <SvgIcons name="cross_btn" style={{ width: "20px", height: "20px", color: "#999" }} />
                </button>
                {children}
            </div>
        </div>
    );

    const portalTarget = document.getElementById(PORTAL_ROOT_ID) || document.body;
    return usePortal ? ReactDOM.createPortal(content, portalTarget) : content;
};
